import { FC } from 'react'
import BaseEmpty from '@/components/BaseEmpty'
import styled from 'styled-components'

interface PriceBannerItemProps {
  contentHTML?: string
  isClient?: boolean
  onClick: () => void
}

const PriceBannerItemStyled = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  margin-top: 24px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: var(--color-text-2);
  white-space: break-spaces;
`

const PriceBannerItem: FC<PriceBannerItemProps> = ({ onClick, contentHTML }) => {
  return (
    <PriceBannerItemStyled onClick={() => contentHTML && onClick()}>
      {contentHTML ? contentHTML : <BaseEmpty size="xs" />}
    </PriceBannerItemStyled>
  )
}

export default PriceBannerItem
